// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2KL_Z","requiredAsterisk":"Info_requiredAsterisk__IK1Hh"};